import CompanyLogoFreseniusHSVamed from '../logos/CompanyFreseniusHSVamed';
import CompanyLogoCuralie from '../logos/CompanyLogoCuralie';
import CompanyLogoFMC from '../logos/CompanyLogoFMC';
import CompanyLogoFreseniusManual from '../logos/CompanyLogoFreseniusManual';
import CompanyLogoFSE from '../logos/CompanyLogoFSE';
import CompanyLogoGIJPFooter from '../logos/CompanyLogoGIJPFooter';
import CompanyLogoGIJPLarge from '../logos/CompanyLogoGIJPLarge';
import CompanyLogoGIJPMobile from '../logos/CompanyLogoGIJPMobile';
import CompanyLogoHelios from '../logos/CompanyLogoHelios';
import CompanyLogoKabi from '../logos/CompanyLogoKabi';
import CompanyLogoMeditec from '../logos/CompanyLogoMeditec';
import CompanyLogoNephrocare from '../logos/CompanyLogoNephrocare';
import CompanyLogoQuironPrevencion from '../logos/CompanyLogoQuironPrevencion';
import CompanyLogoQuironSalud from '../logos/CompanyLogoQuironSalud';
import CompanyLogoVamed from '../logos/CompanyLogoVamed';

/**
 * @type {CompanyLogoMapType}
 */
const CompanyLogoMap = {
  FMC: CompanyLogoFMC,
  FRESENIUS_MEDICAL_CARE: CompanyLogoFMC,
  FSE: CompanyLogoFSE,
  FRESENIUS_SE: CompanyLogoFSE,
  FRESENIUS_HEALTH_SERVICES: CompanyLogoFreseniusHSVamed,
  FRESENIUS_MANUAL: CompanyLogoFreseniusManual,
  GIJP_LARGE: CompanyLogoGIJPLarge,
  GIJP_FOOTER: CompanyLogoGIJPFooter,
  GIJP_MOBILE: CompanyLogoGIJPMobile,
  FRESENIUS_HELIOS_QUIRONSALUD: CompanyLogoQuironSalud,
  FRESENIUS_HELIOS_QUIRONPREVENCION: CompanyLogoQuironPrevencion,
  HELIOS: CompanyLogoHelios,
  FRESENIUS_HELIOS: CompanyLogoHelios,
  FRESENIUS_HELIOS_HOSPITALS: CompanyLogoHelios,
  KABI: CompanyLogoKabi,
  FRESENIUS_KABI: CompanyLogoKabi,
  VAMED: CompanyLogoVamed,
  FRESENIUS_VAMED: CompanyLogoVamed,
  NETCARE: CompanyLogoFSE,
  FRESENIUS_NETCARE: CompanyLogoFSE,
  CURALIE: CompanyLogoCuralie,
  FRESENIUS_CURALIE: CompanyLogoCuralie,
  MEDITEC: CompanyLogoMeditec,
  FRESENIUS_MEDITEC: CompanyLogoMeditec,
  FRESENIUS_DIGITAL_TECHNOLOGY: CompanyLogoFSE,
  NEPHROCARE: CompanyLogoNephrocare,
  VIVONIC: CompanyLogoFMC,
  XENIOS: CompanyLogoFMC,
  DEFAULT: CompanyLogoFSE,
};

export default CompanyLogoMap;
